import React from "react";
import PropTypes from "prop-types";

const Radio = ({
    children,
    bindName,
    value,
    customStyles,
    onValueChange,
    currentValue,
    handleOnClick,
}) => {
    const radioStyles = "radio " + customStyles;
    return (
        <label className={radioStyles} onClick={handleOnClick}>
            <input
                name={bindName}
                type="radio"
                value={value}
                onChange={onValueChange}
                checked={currentValue === value}
            />
            {children}
        </label>
    );
};

Radio.propTypes = {
    children: PropTypes.element.isRequired,
    bindName: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    customStyles: PropTypes.string,
    onValueChange: PropTypes.func,
    handleOnClick: PropTypes.func,
    currentValue: PropTypes.any,
};

Radio.defaultProps = {
    customStyles: "",
};

export default Radio;
